import {
    ActionIcon,
    Badge,
    Box,
    Button,
    Checkbox,
    Flex,
    Group,
    Stack,
    Text,
} from '@mantine/core';

import CreateUserRouteModal from '../../modals/CreateUserRouteModal';
import { IconPlus } from '@tabler/icons-react';
import { useDisclosure } from '@mantine/hooks';

const UserRoutesTopToolbar = ({
    filterOptions,
    rightSection,
    actionButtons: ToolbarActions,
    showHidden,
    toggleShowHidden,
}) => {
    const [
        createUserRouteOpened,
        { open: openCreateModal, close: closeCreateModal },
    ] = useDisclosure();

    return (
        <>
            <Flex
                px={'md'}
                w={'100%'}
                align={'center'}
                justify={'flex-end'}>
                <Button
                    size={'compact-xs'}
                    leftSection={
                        <IconPlus
                            style={{ width: '70%', height: '70%' }}
                            stroke={1.5}
                        />
                    }
                    styles={{
                        section: {
                            marginInlineEnd: 0,
                        },
                    }}
                    onClick={openCreateModal}>
                    Add User Route
                </Button>
                <Group
                    ms={'xs'}
                    gap={'xs'}
                    align={'center'}>
                    {ToolbarActions ? <ToolbarActions /> : null}
                </Group>
            </Flex>
            <CreateUserRouteModal
                routeId={0}
                opened={createUserRouteOpened}
                close={closeCreateModal}
            />
        </>
    );
};
export default UserRoutesTopToolbar;
